export enum EAppsFlyerProperties {
  USER_ID = 'af_user_id',
  REGISTRATION_METHOD = 'af_registration_method', // it is optional if only 1 method
  TIMESTAMP = 'af_timestamp', // it is optional
  REFERRAL_CODE = 'af_referral_code', // if applicable
  CAMPAIGN_SOURCE = 'af_campaign_source', // optional if available

  SESSION_ID = 'af_session_id',
  START_TIME = 'af_start_time',
  END_TIME = 'af_end_time',
  DEVICE_TYPE = 'af_device_type',
  SESSION_DURATION = 'af_session_duration',

  // Deep linking properties
  MEDIA_SOURCE = 'media_source',
  CAMPAIGN = 'campaign',
  AD_ID = 'af_ad',
  AF_XP = 'af_xp',
  DEEP_LINK_VALUE = 'deep_link_value',
  ENTRY_SOURCE = 'entry_source',
  GEO = 'geo',
  DEVICE = 'device',

  // Event-specific properties (PII for demo signup)
  PHONE_NUMBER = 'phone_number',
  EMAIL = 'email',
  NAME = 'name'
}

export enum EAppsFlyerEventNames {
  REGISTRATION = 'registration',
  SESSION_START = 'session_start',
  SESSION_END = 'session_end',
  DEMO_SIGNUP = 'demo_signup',
  DEMO_SIGNUP_PAGE_VIEW = 'demo_signup_page_view',
  APP_HOME_PAGE_VIEW = 'app_home_page_view'
}

export enum EAppsFlyerAppPlatform {
  IOS = 'aqx-ios-mt5-terminal',
  ANDROID = 'aqx-android-mt5-terminal',
  WEB = 'aqx-web-mt5-terminal'
}

export enum EAppsFlyerDeepLinkValue {
  DEMO_SIGNUP_PAGE = 'DEMO_SIGNUP_PAGE',
  HOME = 'HOME',
  DEMO_LOGIN = 'DEMO_LOGIN'
}
